export default function initFundSlider() {
  const wrap = document.querySelector(".fund-slider-component")

  if (!wrap) return

  setSizes()

  // vite hack cause of slow loading
  setTimeout(() => {
    setSizes()
  }, 1000)

  window.addEventListener("resize", setSizes)

  function setSizes() {
    let maxH = 0
    const slides = wrap.querySelectorAll(".slide-text")

    const hiddenClass = "opacity-0"
    slides.forEach((slide, index) => {
      if (index > 0) {
        slide.classList.remove(hiddenClass)
      }

      const slideH = slide.offsetHeight

      maxH = slideH > maxH ? slideH : maxH

      if (index > 0) {
        slide.classList.add(hiddenClass)
      }
    })

    const slidesWrap = wrap.querySelector(".slides-wrap")
    slidesWrap.style.height = `${maxH}px`
    // wrap.querySelector(
    //   ".buttons-wrap"
    // ).style.widht = `${slidesWrap.offsetWidth}px`
  }
}
